import React from 'react'
import { useTranslation } from 'react-i18next'
import { SECTION } from 'utils/section'
import symbol from 'assets/img/symbol-lightgreen.svg'
import image from 'assets/img/lauri-avartek.jpeg'
import styles from './Company.module.scss'

export const Company = () => {
  const { t } = useTranslation()
  return (
    <section id={SECTION.COMPANY} className={styles['section']}>
      <div className={styles['container']}>
        <img className={styles['symbol']} src={symbol} alt="PreFor" />
        <h5 className={styles['slogan']}>{t('company.slogan')}</h5>
        <h2 className={styles['title']}>{t('company.title')}</h2>
        <p className={styles['description']}>{t('company.description')}</p>
        <img className={styles['image']} src={image} alt="Lauri Avartek" />
      </div>
    </section>
  )
}
